module.exports = __webpack_public_path__ + "assets/e90c4a8e1cf751f1a6f579b919f2884d.mp3";